const {paramStore} = require('../../../../../../stores');
const withState = require('../../../../../../utils/withState');
const SecondLayerMenu = require('../SecondLayerMenu');
const AdminPageHeader = require('../AdminPageHeader');
const React = require('react');
const Loading = require('../../../../Loading');
const {apiAdminRetailersStatistic} = require("../../../../../../api/admin/retailers");

const tabs$ = paramStore('userData', 'data');

module.exports = withState((setState, self, onMount) => {
  self.state = {
    ...self.state,
    data: {},
    loading: true,
  };

  const getUserData = () => {
    setState({loading: true});
    const params = self.props.params;
    const userDataRequest = self.props.userDataRequest;

    if (!userDataRequest) {
      setState({loading: false});
      return;
    }

    return userDataRequest({id: params.id})
      .then((res) => {
        setState({loading: false, data: res});
      })
  };

  onMount(getUserData);

  return (state, props) => {

    const {
      loading,
      data,
      currentTab
    } = state;

    if (loading) return <Loading />;

    // const defaultHeaderTitleHandler = (data) => [data.first_name, data.second_name].join(" ");
    const defaultHeaderTitleHandler = (data) => data.name;
    const defaultHeaderStatisticsHandler = (data) => ({
      // display: [
      //   {title: 'Total', dataKey: 'total'},
      //   {title: 'Current Month', dataKey: 'monthly'}
      // ],
      // request: () => (
      //   apiAdminRetailersStatistic()
      //     .then((res) => res.accounts_overview)
      //     .then((res) => ({
      //       total: String(res.total),
      //       monthly: String(res.this_month)
      //     }))
      // )
    });

    const {
      backLink,
      headerTitleHandler = defaultHeaderTitleHandler,
      headerStatisticsHandler = defaultHeaderStatisticsHandler,
      params = {},
      links = [],
      views = {}
    } = props;

    const View = views[currentTab || links[0].id];

    return (
      <>
        <AdminPageHeader
          backLink={backLink}
          title={headerTitleHandler(data)}
          statistic={headerStatisticsHandler(data)}
        />
        <div className="mt30">
          <SecondLayerMenu
            emitter={tabs$}
            links={links}
          />
        </div>
        <View
          userId={params.id}
          userData={data}
          reloadPageData={getUserData}
        />
      </>
    )
  }

}, {
  currentTab: tabs$
});
